import { useEffect, useState } from 'react';

import { MESSAGING_QUERY_KEY } from 'cpool-constants';

import { API } from '~/config.ts';
import FinishedRegister from '~/features/auth/components/FinishedRegister.tsx';
import Set2FA from '~/features/auth/components/Set2FA.tsx';
import SetAvatar from '~/features/auth/components/SetAvatar.tsx';
import SetPassword from '~/features/auth/components/SetPassword.tsx';
import type { SchemaRegisterStep } from '~/features/auth/schemas/registerStep.schema.ts';
import { apiCall } from '~/features/auth/utils/apiCall.ts';

export type NextType = {
    next: () => void;
};
const Register = () => {
    const [step, gotoStep] = useState<number>(0);
    const [response2FA, setResponse2FA] = useState(null);
    const [error2FA, setError2FA] = useState<string | null>(null);
    const next = () => gotoStep(step + 1);

    const request2FA = async () => {
        try {
            const response = await apiCall({
                body: JSON.stringify({ code: true }),
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await response.json();
            if (!data) {
                throw new Error('No data returned from the server');
            }
            setResponse2FA(data);
        } catch (error) {
            setError2FA(error instanceof Error ? error.message : 'An unexpected error occurred');
            throw error;
        }
    };

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const id = query.get(MESSAGING_QUERY_KEY);
        fetch(`${API.URL}/register/step?${MESSAGING_QUERY_KEY}=${id}`, {
            method: 'get',
        })
            .then((response) => response.json() as Promise<SchemaRegisterStep>)
            .then((data) => {
                // if the step is 3 then request we would need to request 2FA again since we NEED the qr code which we do not save anywhere
                if (data.step === 3) {
                    gotoStep(3);
                    request2FA();
                } else gotoStep(data.step);
            });
    }, []);

    return (
        <section className="page">
            <section className="content">
                {step === 1 && <SetPassword next={next} />}
                {step === 2 && (
                    <SetAvatar
                        next={() => {
                            next();
                            request2FA();
                        }}
                    />
                )}
                {step === 3 && (
                    <Set2FA next={next} response2FA={response2FA} error2FA={error2FA} setError2FA={setError2FA} />
                )}
                {step === 4 && <FinishedRegister />}
            </section>
        </section>
    );
};

export default Register;
